import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  ThemeProvider,
  Typography,
  createTheme,
  Box,
  useMediaQuery,
} from "@mui/material";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

const StartGuideDialog = ({ startGuide }) => {
  const [open, setOpen] = useState(true);
  const isPhone = useMediaQuery("(max-width:600px)");
  const isLandscape = useMediaQuery("(orientation: landscape)");
  const dialogWidth = isPhone
    ? isLandscape
      ? "76vw"
      : "92vw"
    : "400px";
  const dialogMargin = isPhone ? "12px auto" : "150px";

  // Function to request microphone access
  const handleStartGuide = async () => {
    try {
      startGuide && startGuide();
      setOpen(false);
    } catch (error) {
      console.error("Error starting guide:", error);
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <Dialog
        open={open}
        fullWidth
        maxWidth="sm"
        sx={{
          "& .MuiDialog-container": {
            alignItems: isPhone && isLandscape ? "flex-start" : "center", // keep dialog visible in landscape
            padding: isPhone ? "12px" : undefined, // keep desktop default spacing
          },
        }}
        PaperProps={{
          sx: isPhone
            ? {
                width: dialogWidth,
                maxWidth: dialogWidth,
                margin: dialogMargin,
                borderRadius: 2,
                px: "var(--dialog-padding, 24px)",
                py: 2,
              }
            : {
                width: "400px",
                maxWidth: "400px",
                margin: "150px",
              },
        }}
      >
        <DialogTitle>Ready to start?</DialogTitle>
        <DialogContent>
          <Typography>
            Begin your experience - make sure to turn up your audio to hear the Guide. To navigate, zoom in and out using your scroll wheel or trackpad.
          </Typography>
          <Box mt={2}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleStartGuide}
            >
              Start Guide
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

     
    </ThemeProvider>
  );
};

export default StartGuideDialog;
